import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CourseVideoTabs from '../CourseVideoTabs';
import CourseCTA from '../CourseCTA';
import CourseCTABottom from '../CourseCTABottom';
import imgTutor from '../../img/filler/tutor.png';

class CourseDetails extends Component {
  render () {
    const course = this.props.course;
    return (
      <article className='primary course-detail'>

        <CourseCTA
          course={course}
          onFreeTrialClick={this.handleFreeTrialClick}
          onBuyNowClick={this.handleBuyNowClick}
        />

        <CourseVideoTabs
          introVideo={course.salesSiteVideoEmbedCode}
          sampleVideo={course.salesSiteSampleVideoEmbedCode}
        />

        <p className='lede' dangerouslySetInnerHTML={{__html: course.specSummary}} />

        <div className='l-columns l-columns--2'>
          <section className='course-detail__aims'>
            <h2>Course Aims</h2>
            <span className='course-aims' dangerouslySetInnerHTML={{ __html: course.aims }} />
          </section>

          <section className='course-detail__tutor'>
            <h2>Your Instructors</h2>
            <img src={imgTutor} alt='Tutor name' />
            <p>Rachael will be your instructor throughout the video classes. You will also be assigned one of our six expert tutors for your one-to-one tutorials and assessments who will be on hand to help with any questions. You're in safe hands. <br /></p>
          </section>
        </div>

        <h2>More information</h2>
        <h3 className='delta'>Course requirements</h3>
        <a href='/requirements' target='_blank' rel='noopener noreferrer'>Click here to view requirements</a>
        <h3 className='delta'>Number of tutorials</h3>
        <p>{course.courseOptions[0].courseDurationWeeks} x {course.tutorialLengthMinutes} minute tutorials <br /></p>
        <h3 className='delta'>Course duration</h3>
        <p>This course lasts {course.courseOptions[0].courseDurationWeeks} weeks <br />
        Number of weeks advertised is the minimum duration. Maximum duration (course 'deadline') is 60 weeks. Extension charges are applicable should the student wish to continue after 60 weeks. Please see terms for more information.</p>

        <div className='u-text-center u-push--top--2'>
          <h2>Here's what some of our students say</h2>
          <span dangerouslySetInnerHTML={{ __html: course.testimonials }} />
        </div>

        <CourseCTABottom
          course={course}
          onFreeTrialClick={this.handleFreeTrialClick}
          onBuyNowClick={this.handleBuyNowClick}
        />

      </article>
    );
  }
}

CourseDetails.propTypes = {
  course: PropTypes.object.isRequired
};

export default CourseDetails;



// WEBPACK FOOTER //
// ./src/components/CourseDetails/index.js